import { Holiday } from '@/src/constants/holidayCalendarConfig'
import { IRange } from '@/src/components/desktop/srp/searchHeader/searchModifierInputs/hooks/search-inputs-manager'
import dayjs from 'dayjs'

/**
 * Calculates date selection based on holiday and trip type
 * @param holiday - Holiday object with dateRange
 * @param isRoundTrip - Whether it's a round trip booking
 * @param currentDate - Current date (defaults to today)
 * @returns Date range object for selection
 */
export const getHolidaySelectionDates = (
    holiday: Holiday,
    isRoundTrip: boolean,
    currentDate: Date = new Date()
): IRange => {
    const today = dayjs(currentDate).startOf('day')
    const fromDate = dayjs(holiday.dateRange.from).startOf('day')
    const toDate = dayjs(holiday.dateRange.to).startOf('day')

    // One-way: Select only from date
    if (!isRoundTrip) {
        // If from date has passed, select current date, otherwise use from date
        const selectedDate = fromDate.isBefore(today) ? today : fromDate
        const selectedDateObj = selectedDate.toDate()
        return {
            from: selectedDateObj,
            to: selectedDateObj, // Use same date for one-way (IRange requires all fields)
            enteredTo: selectedDateObj
        }
    }

    // Round trip: Select both dates
    // If from date has passed, use today as from date
    if (fromDate.isBefore(today)) {
        return {
            from: today.toDate(),
            to: toDate.toDate(),
            enteredTo: toDate.toDate()
        }
    }

    // From date is today or in future
    return {
        from: fromDate.toDate(),
        to: toDate.toDate(),
        enteredTo: toDate.toDate()
    }
}

